import { useTranslation } from "react-i18next";
import { SWMLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";

const Solid_waste_management_faqs = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="" />
          <div className="container">
            <div className="section-main-heading2"></div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {SWMLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Solid Waste Management Dept. :: FAQs")}
                    </h3>
                  </div>
                  <div className="col-lg-6">
                    <div id="accordion">
                      <div className="card">
                        <div className="card-header" id="heading1">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse1"
                            aria-expanded="true"
                            aria-controls="collapse1"
                          >
                            {t(
                              "1 . What are the key activities of the department?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse1"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "The key activities of the department include,"
                              )}
                              <br />
                              {t(
                                "a. Collection of waste from households, commercial and institutional areas"
                              )}
                              <br />
                              {t(
                                "b. Transportation of waste to landfill sites"
                              )}
                              <br />
                              {t("c. Maintenance of landfill sites ")}
                              <br />
                              {t("d. Street sweeping and washing ")}
                              <br />
                              {t("e. Removal of carcass from roads.")}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading2">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse2"
                            aria-expanded="true"
                            aria-controls="collapse2"
                          >
                            {t(
                              "2 . What permission is needed to erect scaffolding? What are the costs involved? How long does it take to obtain permission?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse2"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "In order to erect scaffolding or temporary structure on roads you will need to obtain permission from the Assistant Director of your borough. Please write a letter to the Assistant Director of your borough detailing the location, size and the duration for which the scaffolding needs to be erected. Please visit your local ward office or borough office as per your convenience and present this letter to conservancy officer at these locations. The conservancy officer will visit your proposed location for inspection & will hand you a cash voucher. Please refer to Annex B (Available Online) for the schedule of fees for the same."
                              )}
                            </p>
                            <p className="fontSizeClass">
                              {t(
                                "In most cases preparing the letter to the Assistant Director is not a requirement. You may visit your local borough or ward office and contact the Conservancy officer who will visit your premises & request you to make a payment per schedule of fees. Upon payment you will be handed a cash voucher. This is deemed as your permission for scaffolding etc. You may pay to the CO by cash or DD in favor of KMC made payable at Kolkata."
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading3">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse3"
                            aria-expanded="true"
                            aria-controls="collapse3"
                          >
                            {t(
                              "3 . What time of the day does the KMC truck come to clear garbage ?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse3"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            {t(
                              "KMC trucks come for garbage collection between 6:30AM and 9:30 AM."
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading4">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse4"
                            aria-expanded="true"
                            aria-controls="collapse4"
                          >
                            {t(
                              "4 . What are key locations for solid waste department landfills ?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse4"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "Key locations for solid waste management are Dhapa and Garden Reach. For questions regarding Dhapa, please contact Executive Engineer (C1), Solid Waste Department, 48 Market Street, Kolkata 400 087, Phone – 22861000, Extension 2655. For questions regarding Garden Reach please contact Assistant Director, E/3 Circular Garden Reach Road, Kolkata 700 024, Phone – 2469 6049"
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading5">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse5"
                            aria-expanded="true"
                            aria-controls="collapse5"
                          >
                            {t(
                              "5 . Who do I contact if I see carcass not being cleared in a certain location?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse5"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "Please contact the Assistant Director of the borough that serves your ward. Please refer to the table below for contact details of borough offices"
                              )}
                              .
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading10">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse10"
                            aria-expanded="true"
                            aria-controls="collapse10"
                          >
                            {t(
                              "6 . Who do I contact if I see miscreants create excess garbage at certain locations?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse10"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "A We strongly encourage responsible citizens to inform us in case they notice miscreants creating excess amounts of garbage. Your name and particulars will kept absolutely confidential. You may inform concerned Assistant Director at the borough offices as per addresses inthe table below.You may also drop in a letter or email directly to the Municipal Commissioner of Kolkata (email – mc@kmcgov.in)."
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading11">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse13"
                            aria-expanded="true"
                            aria-controls="collapse13"
                          >
                            {t(
                              "7 . What is the procedure to reclaim my vehicle after the department has seized it?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse13"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "Vehicles are seized from public streets when they are parked in unauthorized parking zones. KMC urges responsible citizens to park their vehicles only in authorized parking areas in order to avoid towing. In order to reclaim a seized vehicle please take the following steps,"
                              )}
                              <br />
                              {t(
                                "a. Write a letter stating details of vehicle to Assistant Director (Central), Special Action Cell, Solid Waste Department, 48 Market Street, Kolkata 400 087, Phone 22459226"
                              )}
                              <br />
                              {t(
                                "b. Please visit the Assistant director with your letter."
                              )}
                              <br />
                              {t(
                                "c. Please make payment of required charges at the Treasury department at KMC headquarters as per schedule of fees in Annex B & contact the Assistant Director showing receipt of payment. You may pay by cash or DD in favor of KMC made payable at Kolkata."
                              )}
                              <br />
                              {t(
                                "d. Upon verification of payment receipt, the Assistant Director will provide you with a performa authorizing the release of your vehicle and will provide you with details of location of your vehicle."
                              )}
                              <br />
                              {t(
                                "e. Please show the same at KMC parking garage to obtain your vehicle."
                              )}
                            </p>
                          </div>
                        </div>
                      </div>                     
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div id="accordion">
                      <div className="card">
                        <div className="card-header" id="heading11">
                          <button
                            class="btn btn-link fontSizeClass" data-toggle="collapse" 
                            data-target="#collapse11" aria-expanded="true" aria-controls="collapse11">
                            {t(
                              "8 . What locations are vehicles parked once the solid waste department seizes them?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse11" className="collapse" data-parent="#accordion">
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "Vehicles are parked within designated KMC designated parking garages."
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading6">
                          <button
                            class="btn btn-link fontSizeClass" data-toggle="collapse"
                            data-target="#collapse6" aria-expanded="true" aria-controls="collapse6">
                            {t(
                              "9 . How does the solid waste department help during periods of natural calamities?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse6"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "The solid waste department makes every effort to be in the forefront of disaster management and recovery in case of natural calamities. The department ensures that it clears debris, clears carcasses, cleans roads and aids citizens with rescue operations."
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading7">
                          <button
                            class="btn btn-link fontSizeClass" data-toggle="collapse"
                            data-target="#collapse7" aria-expanded="true" aria-controls="collapse7">
                            {t(
                              "10 . Who do I contact if the garbage collectors of the department misbehave or do not perform their duties well?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse7"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "The solid waste department is very keen that garbage collectors perform their duties to the satisfaction of citizens of Kolkata. Additionally, it is very important that garbage collectors behave well and help Kolkatans keep clean streets. If you are not happy with KMC’s garbage collectors please contact,"
                              )}
                              {t("Assistant Director, Solid Waste Management Department, 48 Market Street, Kolkata 400 087, Phone – 22861000, Extension 2655 .")}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading8">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse" data-target="#collapse8" aria-expanded="true" aria-controls="collapse8">
                            {t( "11 . How are high-speed roadways maintained by KMC ?" )}
                          </button>
                        </div>
                        <div id="collapse8" className="collapse" data-parent="#accordion">
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t(
                                "KMC takes special care of it’s high speed road ways such as EM bypass, P.C. Connector and R.B. Connector. Mechanical sweepers clean these roadways on a daily basis ."
                              )}
                              
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading9">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse" data-target="#collapse9" aria-expanded="true" aria-controls="collapse9" >
                            {t( "12 . Who do I contact if I have storage material such as vegetable oil etc. that has expired ?")}
                          </button>
                        </div>
                        <div id="collapse9" className="collapse" data-parent="#accordion">
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t("If you have material that is not hazardous it can be disposed at KMC landfills. You can either use your own vehicle for the transportation of the same or can avail of KMC vehicles. Please take the following steps to dispose expired material," )}
                              <br />
                              {t("a. Write a letter addressed to Deputy Chief Engineer, Solid Waste Management Department (48 Market Street, Kolkata 400 087) detailing the nature of the waste and the weight of the same.")}
                              <br />
                              {t("b. Based on the schedule of charges in Annex B, you will need to make a payment at the Treasury department of the KMC headquarters.")}
                              <br />
                              {t("c. Upon showing the receipt of payment to Deputy Chief Engineer will provide you with a performa that authorizes garbage collection and disposal at one of the KMC landfills.")}
                              <br />
                              {t("It is recommended that you use your own vehicle for disposal. If you use your vehicle for disposal, you will be given a period of 7 days from the date of grant of permission to dispose off the material. If you request a KMC truck, you will be given garbage pick up date depending on availability of vehicles.")}
                            </p>
                          </div>
                        </div>
                      </div>                                       
                      <div className="card">
                        <div className="card-header" id="heading12">
                          <button class="btn btn-link fontSizeClass" data-toggle="collapse"
                            data-target="#collapse12" aria-expanded="true" aria-controls="collapse12">
                            {t( "13 . Many a times the garbage trucks are not securely covered. In such cases garbage spills over onto the road and/or on passing vehicles and pedestrians. What does KMC do to prevent such a nauseating experience?")}
                          </button>
                        </div>
                        <div
                          id="collapse12" className="collapse" data-parent="#accordion">
                          <div className="card-body m-3">
                            <p className="fontSizeClass">
                              {t("KMC makes every effort that the garbage trucks are securely covered so that there is minimum inconvenience to Kolkatans. The solid waste management department ensures that covers of garbage carriers are replaced every 3 months. In case you notice a garbage spill over from trucks please contact the Deputy Chief Engineer, Solid Waste Management Department, 48 Market Street, Kolkata 400 087, Phone – 22861000, Extension 2649. Agency/contractors that do not maintain proper covers over garbage are fined Rs. 130 to Rs.160 if complaints received are found to be valid.")}
                            </p>
                            <p className="fontSizeClass">
                              <strong>{t("Address of Borough Offices")}</strong>
                            </p>
                            <div className="mayor-table2 depart">
                              <table className="table table-bordered">
                                <thead>
                                  <tr className="table-warning table-bor-2">
                                    <th className="bd-wid" scope="col">
                                      {t("Sl.No.")}
                                    </th>
                                    <th scope="col"> {t("Borough")} </th>
                                    <th scope="col"> {t("Address")} </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td> 1 </td>
                                    <td> I </td>
                                    <td>
                                      {t(
                                        "10, B.T. Road, Cossipore, Kolkata-700002"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 2 </td>
                                    <td> II </td>
                                    <td>
                                      {t(
                                        "79, Bidhan Sarani, Hatibagan, Kolkata-700006"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 3 </td>
                                    <td> III </td>
                                    <td>
                                      {t(
                                        "109, Narkeldanga Road, Fulbagan, Kolkata-700011"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 4 </td>
                                    <td> IV </td>
                                    <td>
                                      {t(
                                        "5, Azad Hind Bag, Hedua Park, Kolkata-700006"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 5 </td>
                                    <td> V </td>
                                    <td>
                                      {t(
                                        "22, Surya Sen Street, College Sqare, Kolkata-700012"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 6 </td>
                                    <td> VI </td>
                                    <td>
                                      {t("1, Hogg Street, Kolkata-700087")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 7 </td>
                                    <td> VII </td>
                                    <td>
                                      {t(
                                        "9/1, A.J.C. Bose Road, Kolkata-700017"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 8 </td>
                                    <td> VIII </td>
                                    <td>
                                      {t("Vivekananda Park, Kolkata-700029")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 9 </td>
                                    <td> IX </td>
                                    <td>
                                      {t(
                                        "11, Belvedere Road, Alipore, Kolkata-700027"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 10 </td>
                                    <td> X </td>
                                    <td>
                                      {t("28, Anoar Shah Road, Kolkata-700033")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 11 </td>
                                    <td> XI </td>
                                    <td> {t("Garia, Atabagan")} </td>
                                  </tr>
                                  <tr>
                                    <td> 12 </td>
                                    <td> XII </td>
                                    <td>
                                      {t(
                                        " 97, Garfa main Road, Kolkata-700075"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 13 </td>
                                    <td> XIII </td>
                                    <td>
                                      {t("516, D.H. Road, Br. Office, Behala")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 14 </td>
                                    <td> XIV </td>
                                    <td>
                                      {t("516, D.H. Road, Br. Office, Behala")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td> 15 </td>
                                    <td> XV </td>
                                    <td>{t("E/3, Garden Reach Br. Office")}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Solid_waste_management_faqs;
